import React from 'react'
import { Logo } from '../components/images';
import { Link } from 'react-router-dom';
import { useAppType } from '../provider/AppTypeProvider';
import { FaUserGraduate, FaBriefcase, FaArrowRight } from 'react-icons/fa';

const MainSignup = () => {
  const { switchAppType } = useAppType();
  
  return (
    <div className='bg-gradient-to-br from-orange-200 to-orange-500 min-h-screen w-full p-4 sm:p-6 lg:p-10'>
      {/* Header */}
      <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 sm:mb-8'>
        <Link to="/main-signup">
            <div className='flex flex-row items-center mb-4 sm:mb-0'>
                <img src={Logo} className='w-8 h-8 sm:w-10 sm:h-10' alt="Logo"/>
                <p className='text-lg sm:text-xl lg:text-2xl ml-2 font-medium text-gray-800'>Oodles Internships</p>
            </div>
        </Link>
        
        <div className='flex sm:flex-row justify-center gap-2 sm:gap-3'>               
            <Link to='/about'                             
            className='text-md sm:text-md hover:underline'               
            >                 
                About               
            </Link>               
            <Link to='/faq'                              
            className='text-md sm:text-md hover:underline'               
            >                 
                FAQs               
            </Link>             
        </div>
      </div>

      {/* Main Content */}
      <div className="flex justify-center items-center px-4">    
        <div className='w-full max-w-md'>
          {/* Welcome Card */}
          <div className='bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10'>
            {/* Header */}
            <div className='text-center mb-8'>
              <h1 className='text-orange-500 text-2xl sm:text-3xl lg:text-4xl font-bold mb-2'>
                Welcome to Oodles
              </h1>
              <h2 className='text-gray-700 text-lg sm:text-xl font-medium mb-2'>
                Internship Platform
              </h2>
              <p className='text-gray-600 text-sm sm:text-base'>
                Choose your role to get started
              </p>
            </div>

            {/* Role Selection Cards */}
            <div className='space-y-4 mb-6'>
              {/* Intern Option */}
              <Link 
                onClick={() => switchAppType('intern')} 
                to='/login' 
                className='group block w-full bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white rounded-xl p-4 sm:p-5 transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg'
              >
                <div className='flex items-center justify-between'>
                  <div className='flex items-center space-x-3'>
                    <div className='bg-white/20 p-2 rounded-lg'>
                      <FaUserGraduate className='w-5 h-5 sm:w-6 sm:h-6' />
                    </div>
                    <div className='text-left'>
                      <h3 className='font-semibold text-lg sm:text-xl'>Intern</h3>
                      <p className='text-orange-100 text-xs sm:text-sm'>
                        Find your perfect internship
                      </p>
                    </div>
                  </div>
                  <FaArrowRight className='w-4 h-4 group-hover:translate-x-1 transition-transform duration-300' />
                </div>
              </Link>

              {/* Employer Option */}
              <Link 
                to='/employer/login' 
                onClick={() => switchAppType('employer')} 
                className='group block w-full bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl p-4 sm:p-5 transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg'
              >
                <div className='flex items-center justify-between'>
                  <div className='flex items-center space-x-3'>
                    <div className='bg-white/20 p-2 rounded-lg'>
                      <FaBriefcase className='w-5 h-5 sm:w-6 sm:h-6' />
                    </div>
                    <div className='text-left'>
                      <h3 className='font-semibold text-lg sm:text-xl'>Employer</h3>
                      <p className='text-gray-300 text-xs sm:text-sm'>
                        Hire talented interns
                      </p>
                    </div>
                  </div>
                  <FaArrowRight className='w-4 h-4 group-hover:translate-x-1 transition-transform duration-300' />
                </div>
              </Link>
            </div>

            {/* Features List */}
            <div className='bg-orange-50 rounded-lg p-4 mb-6'>
              <h4 className='font-medium text-gray-800 mb-3 text-center text-sm sm:text-base'>
                ✨ What you'll get
              </h4>
              <div className='grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs sm:text-sm text-gray-600'>
                <div className='flex items-center space-x-2'>
                  <span className='text-orange-500'>•</span>
                  <span>Easy application process</span>
                </div>
                <div className='flex items-center space-x-2'>
                  <span className='text-orange-500'>•</span>
                  <span>Smart job matching</span>
                </div>
                <div className='flex items-center space-x-2'>
                  <span className='text-orange-500'>•</span>
                  <span>Real-time notifications</span>
                </div>
                <div className='flex items-center space-x-2'>
                  <span className='text-orange-500'>•</span>
                  <span>Career guidance</span>
                </div>
              </div>
            </div>

            {/* Alternative Options */}
            <div className='text-center space-y-3'>
              <p className='text-gray-600 text-xs sm:text-sm'>
                Don't have an account yet?
              </p>
              <div className='flex flex-col sm:flex-row gap-2 sm:gap-3'>
                <Link 
                  to='/register'
                  onClick={() => switchAppType('intern')} 
                  className='flex-1 text-orange-600 hover:text-orange-700 border border-orange-300 hover:border-orange-400 rounded-lg py-2 px-4 text-sm font-medium transition-colors text-center'
                >
                  Sign up as Intern
                </Link>
                <Link 
                  to='/employer/register'
                  onClick={() => switchAppType('employer')} 
                  className='flex-1 text-gray-600 hover:text-gray-700 border border-gray-300 hover:border-gray-400 rounded-lg py-2 px-4 text-sm font-medium transition-colors text-center'
                >
                  Sign up as Employer
                </Link>
              </div>
            </div>
          </div>

          {/* Footer Info */}
          <div className='text-center mt-6 text-white/80'>
            <p className='text-xs sm:text-sm'>
              🚀 Pilot Program in University of Ghana
            </p>
            <p className='text-xs mt-1'>
              Shaping the future of internships
            </p>  
            <a 
                href="/assets/Privacy_Policy.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xs hover:underline"
            >
                Privacy Policy
            </a>
            <a className="text-xs"> • </a>
            <a 
                href="/assets/Terms_and_Conditions.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xs hover:underline"
            >
                Terms and Conditions
            </a>
          </div>
        </div>
      </div>

      {/* Background Decoration */}
      <div className='fixed inset-0 pointer-events-none overflow-hidden -z-10'>
        <div className='absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl'></div>
        <div className='absolute top-40 right-20 w-32 h-32 bg-white/5 rounded-full blur-2xl'></div>
        <div className='absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full blur-xl'></div>
        <div className='absolute bottom-40 right-10 w-16 h-16 bg-white/15 rounded-full blur-lg'></div>
      </div>
    </div>
  )
}

export default MainSignup